module.exports = __webpack_public_path__ + "static/media/fortnite-cover.f6ed43df.jpg";